export default "__VITE_ASSET__DXa_jA7t__"